<template>
  <div id="vue-cp-map-app">
    <CpMap></CpMap>
  </div>
</template>

<script>
import CpMap from './components/CpMap.vue';

export default {
  name: 'vue-app',
  components: {CpMap},
}
</script>

<style lang="scss">
  .google-map-wrapper {
    height: 600px;
  }
</style>



// WEBPACK FOOTER //
// App.vue